// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__A5HHo","label":"Section_label__3J5St","contentWrap":"Section_contentWrap__2a3SN","footer":"Section_footer__1MLfX","footerInner":"Section_footerInner__3ibiE"};